// extracted by mini-css-extract-plugin
module.exports = {"root":"DuaMessageContainer_root_130ms","eventContainer":"DuaMessageContainer_eventContainer_1l4Rg"};